function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#virus_svg__clip0_75_5000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.875.875a.874.874 0 10-1.75 0v.314c0 1.365-1.649 2.048-2.614 1.083l-.224-.221a.873.873 0 00-1.236 0 .876.876 0 000 1.238l.224.225c.962.962.279 2.611-1.086 2.611H.875a.874.874 0 100 1.75h.314c1.365 0 2.048 1.649 1.083 2.614l-.221.224a.876.876 0 001.238 1.239l.225-.224c.965-.966 2.614-.282 2.614 1.082v.315a.874.874 0 101.75 0v-.315c0-1.364 1.649-2.048 2.614-1.082l.224.224a.877.877 0 001.239-1.239l-.225-.224c-.965-.965-.281-2.614 1.083-2.614h.312a.874.874 0 100-1.75h-.315c-1.364 0-2.048-1.649-1.082-2.614l.224-.224a.877.877 0 00-1.239-1.239l-.224.224c-.965.966-2.614.282-2.614-1.083V.875zm-3.063 5.25a1.312 1.312 0 112.625 0 1.312 1.312 0 01-2.625 0zm3.5 1.531a.656.656 0 110 1.313.656.656 0 010-1.313z",
  fill: "currentColor"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "virus_svg__clip0_75_5000"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h14v14H0z"
})));

var SvgVirus = function SvgVirus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgVirus;